import { z } from 'zod';

/** Fecha ISO YYYY-MM-DD (sin hora). null limpia el campo en la API. */
const fechaISO = z
  .string()
  .regex(/^\d{4}-\d{2}-\d{2}$/, 'fecha inválida: use el formato YYYY-MM-DD');

export const CreateServicioDtoSchema = z.object({
  idCliente: z.coerce.number().int(),
  idPlan: z.coerce.number().int(),
  idTipoServicio: z.coerce.number().int(),
  idEstado: z.coerce.number().int().optional(),
  idMunicipio: z.coerce.number().int().optional(),
  idDepartamento: z.coerce.number().int().optional(),
  fechaInicio: fechaISO.nullable().optional(),
  direccion: z.string().optional(),
  referencia: z.string().optional(),
  latitud: z.coerce.number().optional(),
  longitud: z.coerce.number().optional(),
});

export type CreateServicioDto = z.infer<typeof CreateServicioDtoSchema>;

/**
 * Update de servicio: NO admite cambiar cliente, tipo de servicio, fechaInicio
 * ni fechaCobro — todos son inmutables tras la contratación.
 *  - cliente/tipo: reescribirían la identidad del servicio sin dejar rastro.
 *  - fechaInicio: representa cuándo se contrató, no un parámetro operacional.
 *  - fechaCobro: la facturación usa `cliente.fecha_cobro` y `cliente.dia_cobro`;
 *    `servicio.fecha_cobro` era un campo muerto (no lo leía ningún flujo).
 * El plan sí se puede cambiar: queda registrado en servicio_plan_historial con
 * efecto el 1° del próximo mes.
 */
export const UpdateServicioDtoSchema = z.object({
  idPlan: z.coerce.number().int().optional(),
  idEstado: z.coerce.number().int().optional(),
  idMunicipio: z.coerce.number().int().optional(),
  idDepartamento: z.coerce.number().int().optional(),
  direccion: z.string().optional(),
  referencia: z.string().optional(),
  latitud: z.coerce.number().optional(),
  longitud: z.coerce.number().optional(),
});

export type UpdateServicioDto = z.infer<typeof UpdateServicioDtoSchema>;

export const QueryServiciosDtoSchema = z.object({
  offset: z.coerce.number().int().min(0).default(0),
  limit: z.coerce.number().int().min(1).max(100).default(20),
  search: z.string().optional(),
  estado: z.coerce.number().int().optional(),
  idCliente: z.coerce.number().int().optional(),
  idPlan: z.coerce.number().int().optional(),
  idTipoServicio: z.coerce.number().int().optional(),
});

export type QueryServiciosDto = z.infer<typeof QueryServiciosDtoSchema>;
